import { render, staticRenderFns } from "./officialBar.vue?vue&type=template&id=6596001b&"
import script from "./officialBar.vue?vue&type=script&lang=js&"
export * from "./officialBar.vue?vue&type=script&lang=js&"
import style0 from "./officialBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports